import { IconDefinition } from "./types";

const youtube: IconDefinition = {
  iconName: "youtube",
  width: 16,
  height: 16,
  svgPathData:
    "M6.36666667,10.708 L6.36666667,4.93333333 L10.8793333,7.82066667 L6.36666667,10.708 Z M15.5333333,4.95933333 C15.5333333,3.69266667 14.5073333,2.66666667 13.242,2.66666667 L2.82533333,2.66666667 C1.55933333,2.66666667 0.533333333,3.69266667 0.533333333,4.95933333 L0.533333333,11.04 C0.533333333,12.3073333 1.55933333,13.3333333 2.82533333,13.3333333 L13.242,13.3333333 C14.5073333,13.3333333 15.5333333,12.3073333 15.5333333,11.04 L15.5333333,4.95933333 Z",
  iconType: "fill",
};

export { youtube };
